// extracted by mini-css-extract-plugin
export const hamburger = "hamburger-module--hamburger--1nI_j";
export const isActive = "hamburger-module--isActive--KQnIR";
export const hamburgerInner = "hamburger-module--hamburgerInner--2GaZW";
export const hamburgerBox = "hamburger-module--hamburgerBox--3joxC";
export const hamburgerCollapse = "hamburger-module--hamburgerCollapse--1snAn";
export const hamburgerCollapseR = "hamburger-module--hamburgerCollapseR--39oEz";